import React, {Component, createContext } from 'react'
import MunicipioService from '@/app/api/service/MunicipioService';
import ObraService from '@/app/api/service/ObrasService';

export const ObraContext = createContext({})
export const Consumer = ObraContext.Consumer;
const Provider = ObraContext.Provider

const initialState = {
    municipioSelecionado: null,
    municipioPesquisado: null,
    municipios : [],
    situacaoSelecionada: null,
    situacoes: [],
    obras: [],
    obrasSnapshot: [],
    noResult: false,
    renderSituacaoFiltro: false,
    quantidadeRegistros: null,
    mensagemResultadoConsulta: "",
    renderGrafico: false,
    graficoData: null,
    showConsultarBtn: true,
    inep: null,
    descricaoUnidadeTrabalho: null
}

export default class ObraContextProvider extends Component {

    state = initialState

    constructor(props){
        super(props);
        this.municipioService = new MunicipioService()
        this.obrasService = new ObraService()
    }

    render(){

        const value = {
            listarMunicipios: this.listarMunicipios,
            consultarObras: this.consultarObras,
            municipios: this.state.municipios,
            filtarPorStatus: this.filtarPorStatus,
            onMunicipioChange: this.onMunicipioChange,
            limparConsulta: this.limparConsulta,
            iniciaConsultaObras: this.cleanState,
            onInputChange: this.onInputChange,
            ...this.state
        }

        return(
            <Provider value={value}>
                {this.props.children}
            </Provider>
        )
    }

    listarMunicipios = async () => {
        const municipiosRes = await this.municipioService.get('')
        this.setState({ municipios : municipiosRes.data })      
    }

    gerarDadosGrafico = (labelStatus, quantidadeStatus) => {
        let labels = labelStatus

        //tirando o primeiro de cada pq são inválidos
        labels.shift();
        quantidadeStatus.shift();

        return {
            labels: labels,
            datasets: [
                {
                    data: quantidadeStatus,
                    backgroundColor: [
                        "#FF0000",
                        "#FFD700",
                        "orange",
                        "#FF00FF",                        
                        "#4876FF",
                        "#00FA9A",
                        "#CAE1FF",
                        "#191970",
                        "#FFD700"
                    ]
                }
            ]
        }
    }

    consultarObras = async () => {
        let municipio = this.state.municipioSelecionado || {}

        if(!municipio.id){
            municipio = {}
        }

        const filtro = {
            municipio,
            inep: this.state.inep,
            descricaoUnidadeTrabalho: this.state.descricaoUnidadeTrabalho
        }

        const response = await this.obrasService.post(filtro)
        const obras = response.data.processos
        const quantidadeObras = obras ? obras.length : 0
        
        let allStatus = [{index: null, descricao: `Todas (${quantidadeObras})`}].concat(response.data.allStatus)
        
        const labelStatus = allStatus.map(s => s.descricao)
        const quantidadeStatus = allStatus.map(s => s.quantidade )
        
        allStatus = allStatus.map( status => {
            if(status.index !== null){
                status.descricao = status.descricao + `(${status.quantidade})`
            }

            return status;
        })

        const noResult = quantidadeObras === 0

        const mensagemResultadoConsulta =  this.gerarMensagemResultado( municipio, quantidadeObras );
        const graficoData = this.gerarDadosGrafico(labelStatus, quantidadeStatus)

        this.setState({
            obrasSnapshot: obras,
            obras, 
            situacaoSelecionada: null,
            situacoes: allStatus,
            renderSituacaoFiltro: !noResult,
            renderGrafico: !noResult,
            quantidadeRegistros: quantidadeObras,
            municipioPesquisado: municipio,
            mensagemResultadoConsulta,
            graficoData,
            noResult,
            showConsultarBtn: false
        })


    }

    gerarMensagemResultado = ( municipioPesquisado, quantidadeRegistros ) => {
        const municipioBusca = ( municipioPesquisado && municipioPesquisado.id && `no Município de ${municipioPesquisado.descricao}`) || 'em todo o Ceará.'
        let mensagemResultado = false; 
            
        if( quantidadeRegistros ){
            mensagemResultado =  quantidadeRegistros === 0 ?
                     `Nenhum registro encontrado em ${municipioBusca}.` :  
                     `${quantidadeRegistros} Obra(s) ${municipioBusca}` ;
        }

        return mensagemResultado;
    }

    filtarPorStatus = (event) => {
        const status = event.value;

        if(status){
            const obrasFiltradas = status.index === null ? this.state.obrasSnapshot : this.state.obrasSnapshot.filter( obra => obra.status === status.index )
            const quantidadeRegistros = status.quantidade === 0 ? null : status.quantidade

            this.setState({ 
                obras: obrasFiltradas, 
                situacaoSelecionada: status, 
                quantidadeRegistros,
                mensagemResultadoConsulta: this.gerarMensagemResultado( this.props.municipioPesquisado, obrasFiltradas.length )
            })
        }
    }

    onMunicipioChange = (e) =>{
        this.setState({
            municipioSelecionado: e.value,
            renderSituacaoFiltro: false,
            renderGrafico: false
        })
    }

    onInputChange = (event) => {
        this.setState({ [event.target.name] : event.target.value })
    }

    limparConsulta = () => {
        this.setState({
            situacaoSelecionada: null, 
            municipioSelecionado : null,
            renderSituacaoFiltro: false,
            renderGrafico: false,
            showConsultarBtn: true,
            obras: [],
            obrasSnapshot: [],
            inep: null,
            descricaoUnidadeTrabalho: null
        })
    }    

    cleanState = () => {
        this.setState({...initialState, municipios: this.state.municipios})
    } 

    componentDidMount(){
        this.cleanState()
    }
}